export const noReliableSourceLabel = "Надёжного источника нет";

export const regenerateLabel = "Сгенерировать заново";

export const chatAskStopLabel = "Стоп";

export const chatStoppedLabel = "Остановлено";

export const chatAskFailedLabel = "Не удалось подготовить ответ.";

export const chatAskFailedDetailsLabel = "Подробности";

export function chatFailedDetail(detail: string | null | undefined): string | null {
  const text = detail?.trim() ?? "";
  if (!text || text === chatAskFailedLabel) {
    return null;
  }
  return text;
}

export const chatLoadingPhrases = [
  "Ищем в знаниях…",
  "Сверяем источники…",
  "Готовим ответ…",
] as const;

function sourceWord(count: number): string {
  const n = Math.abs(count) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return "источников";
  }
  if (n1 === 1) {
    return "источника";
  }
  return "источников";
}

export function chatTrustLabel(input: {
  status: "answered" | "no_sources";
  sourceCount: number;
  conflictCount?: number;
}): string {
  if (input.status === "no_sources" || input.sourceCount <= 0) {
    return noReliableSourceLabel;
  }
  const base = `На основе ${input.sourceCount} ${sourceWord(input.sourceCount)}`;
  if (input.conflictCount != null && input.conflictCount >= 2) {
    return `${base} · ${input.conflictCount} не сходятся`;
  }
  return base;
}
